var React = require('react');

function Carrotdown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0.954545L1.04 0L6.5 5.07818L11.96 0L13 0.954545L6.5 7L0 0.954545Z","fill":"white"}));
}

Carrotdown.defaultProps = {"width":"13","height":"7","viewBox":"0 0 13 7","fill":"none"};

module.exports = Carrotdown;

Carrotdown.default = Carrotdown;
